import { render } from "./LottieAnimation.vue?vue&type=template&id=3fe0a20e"
import script from "./LottieAnimation.vue?vue&type=script&lang=js"
export * from "./LottieAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__